import { Component, Input, OnInit } from '@angular/core';
import { Association } from '../../../../../../../models/association';
import { CallbackResult } from '../../../../../../../utils';
import {
  getMembershipDiscountApplyMethodDisplay,
  MembershipDiscount
} from '../../../../../../../models/membership';
import { EntryPassDiscount} from '../../../../../../../models/entry-pass';
import { EventDiscount} from '../../../../../../../models/event-type';
import { AccountService } from '../../../../../../../services/account/account.service';
import { MembershipService } from '../../../../../../../services/membership/membership.service';
import { EntryPassService } from '../../../../../../../services/entry-pass/entry-pass.service';
import { EventTypeService } from '../../../../../../../services/event-type/event-type.service';
import { OrganizationConfigService } from '../../../../../../../services/organization-config/organization-config.service';
import { EventDiscountType } from '../../../../../../../models/event-type-enums';
import { EntryPassDiscountType } from '../../../../../../../models/entry-pass-enums';
import { MembershipDiscountType } from '../../../../../../../models/membership-enums';


@Component({
  selector: 'app-association-discounts-sub-list',
  templateUrl: './association-discounts-sub-list.component.html',
  styleUrls: ['./association-discounts-sub-list.component.css']
})
export class AssociationDiscountsSubListComponent implements OnInit {
  @Input() association: Association;
  @Input() resultCallback: (result: CallbackResult) => void;

  public membershipDiscountList: MembershipDiscount[];
  public entryPassDiscountList: EntryPassDiscount[];
  public eventDiscountList: EventDiscount[];

  public loadingMembershipDiscounts = true;
  public loadingEntryPassDiscounts = true;
  public loadingEventDiscounts = true;

  public serverError: number = null;

  public MembershipDiscountType = MembershipDiscountType;
  public EntryPassDiscountType = EntryPassDiscountType;
  public EventDiscountType = EventDiscountType;
  public getMembershipDiscountApplyMethodDisplay = getMembershipDiscountApplyMethodDisplay;

  constructor(
    public orgConfig: OrganizationConfigService,
    private accountService: AccountService,
    private membershipService: MembershipService,
    private entryPassService: EntryPassService,
    private eventTypeService: EventTypeService
  ) {}

  ngOnInit() {
    this.loadMembershipDiscounts();
    this.loadEntryPassDiscounts();
    this.loadEventDiscounts();
  }

  public loadMembershipDiscounts() {
    this.loadingMembershipDiscounts = true;

    this.membershipService
      .getMembershipDiscounts(
      1,
      100,
      {association_id: this.association.id}
      )
      .then(response => {
        this.membershipDiscountList = response.results;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingMembershipDiscounts = false; });
  }

  public loadEntryPassDiscounts() {
    this.loadingEntryPassDiscounts = true;

    this.entryPassService
      .getEntryPassDiscounts(
      1,
      100,
      {association_id: this.association.id}
      )
      .then(response => {
        this.entryPassDiscountList = response.results;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingEntryPassDiscounts = false; });
  }

  public loadEventDiscounts() {
    this.loadingEventDiscounts = true;

    this.eventTypeService
      .getEventDiscounts(
      1,
      100,
      {association_id: this.association.id}
      )
      .then(response => {
        this.eventDiscountList = response.results;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingEventDiscounts = false; });
  }
}
